<template>
	<footer id="footer" class="footer">
		<!-- <UIHeading level="2" class="footer__title">Контакты</UIHeading> -->
		<div class="footer__container container">
			<div class="footer__content">
				<Contacts />
				<!-- <video
					ref="videoRef"
					muted
					playsinline
					poster="/images/sections/footer/videoframe_0.jpg"
					class="footer__video"></video> -->
				<video
					id="video-footer"
					ref="footerVideo"
					data-src="https://dcdn.veonadx.com/landingveon/footer-new.mp4"
					data-poster="/images/sections/footer/videoframe_0.webp"
					playsinline
					loop
					muted
					:autoplay="isVideoReady"
					width="1280"
					height="720"
					preload="metadata"
					fetchpriority="low"
					class="footer__video video-preload"
					:poster="isFooterMediaReady ? '/images/sections/footer/videoframe_0.webp' : undefined">
					<track kind="captions" srclang="en" label="English captions" src="/captions/empty.vtt" />
				</video>
				<!-- <Contacts /> -->
			</div>
			<div class="footer__copyright">
				<div class="footer__copyright-year">{{ new Date().getFullYear() }} © VEON AdTech Digital</div>
				<img
					:src="
						isMobile
							? '/images/logo/veon_adtech_digital_white_center.svg'
							: '/images/logo/veon_adtech_digital_white_right.svg'
					"
					width="100"
					height="59"
					alt="VEON AdTech Digital"
					class="footer__copyright-logo" />
			</div>
		</div>
	</footer>
</template>

<script setup lang="ts">
	// const { $createjs } = useNuxtApp()

	const { $gsap: gsap } = useNuxtApp()
	// const videoRef = ref<HTMLVideoElement | null>(null)

	function footerAnimation() {
		gsap
			.timeline({
				scrollTrigger: {
					trigger: '.footer',
					start: 'top bottom',
					end: 'bottom bottom',
					scrub: true,
				},
			})
			.from('.footer__video', {
				scale: 0.5,
				rotate: 50,
				ease: 'none',
			})

		gsap
			.timeline({
				scrollTrigger: {
					trigger: '.main',
					start: 'center bottom',
					end: 'bottom bottom',
					toggleActions: 'play none none reset',
				},
			})
			.from('.footer', {
				opacity: 0,
				ease: 'none',
			})
	}

	const isMobile = computed(() => {
		return import.meta.client ? window.innerWidth < 768 : false
	})

	// function videoAnimationOnScroll() {
	// 	// const video = videoRef.value
	// 	// if (!video) return

	// 	// // Обязательно дождитесь, пока метаданные видео загрузятся
	// 	// video.load()
	// 	// video.addEventListener('loadedmetadata', () => {
	// 	// const duration = video.duration

	// 	gsap.to(videoRef.value, {
	// 		currentTime: videoRef.value?.duration,
	// 		scrollTrigger: {
	// 			trigger: '.footer',
	// 			start: 'top bottom',
	// 			end: 'bottom bottom',
	// 			scrub: true,
	// 		},
	// 		ease: 'none',
	// 		scale: 1,
	// 		// })
	// 	})

	// 	// video.autoplay = false
	// 	// video.currentTime = 0
	// }

	const footerVideo = ref<HTMLVideoElement | null>(null)
	const isVideoReady = ref(false)
const isFooterMediaReady = ref(false)
	let footerVideoObserver: IntersectionObserver | null = null

	function initFooterVideoLoad() {
		if (!import.meta.client || !footerVideo.value || isVideoReady.value) return
		const video = footerVideo.value
		const videoSrc = video.dataset.src
		const posterSrc = video.dataset.poster
		if (!videoSrc) return

		const activateVideo = () => {
			if (isVideoReady.value) return
			if (posterSrc) {
				video.poster = posterSrc
			}
			isFooterMediaReady.value = true
			video.src = videoSrc
			isVideoReady.value = true
			video.play().catch((e) => {
				console.warn('Autoplay failed:', e)
			})
			footerVideoObserver?.disconnect()
			footerVideoObserver = null
		}

		footerVideoObserver = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					activateVideo()
				}
			},
			{
				rootMargin: '300px',
			}
		)

		footerVideoObserver.observe(video)
	}

	onMounted(() => {
		footerAnimation()
		initFooterVideoLoad()
	})

	onBeforeUnmount(() => {
		footerVideoObserver?.disconnect()
	})
</script>

<style scoped lang="scss">
	.footer {
		// overflow: clip;
		// position: relative;
		position: sticky;

		// top: -50px;
		bottom: 50px;

		// position: sticky;
		// top: calc(100vh - 50px);
		// z-index: 1;
		// margin-top: auto;
		// z-index: -1;
		padding-top: 50px;
		background-color: var(--black);

		// z-index: -1;

		@media (width <= 575.98px) {
			position: static;
			padding-bottom: 64px;
		}
		&__title {
			color: var(--white);
			text-align: center;
			text-transform: uppercase;
		}
		&__content {
			position: relative;
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 32px;
			align-items: center;

			@media (width <= 991.98px) {
				grid-template-columns: 1fr;
			}
		}
		&__video {
			width: 100%;
			aspect-ratio: 16 / 9;
			max-height: 500px;
			object-fit: contain;
			clip-path: polygon(0% 0%, 100% 0%, 100% 92%, 0% 100%);

			// transform: scale(0.5);
			@media (width <= 991.98px) {
				position: fixed;
				top: 40vh;
				left: -30%;
				max-height: 300px;
				opacity: 0.5;
			}
		}
		&__copyright {
			position: relative;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 32px;
			font-family: Montserrat, sans-serif;
			color: var(--pure-white);
			text-align: center;

			@media (width <= 575.98px) {
				flex-direction: column-reverse;
			}
			&-logo {
				margin-left: auto;

				@media (width <= 575.98px) {
					margin: 0 auto 24px;
				}
			}
		}
	}
</style>
